import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GridService } from '../shared/grid/grid.service';
import { GridModel } from '../shared/grid/grid.model';
import { SegSamplingPlan, SegSamplingPlanListResponse } from '../models/segSamplingPlan.model';

@Injectable({
    providedIn: 'root'
})
export class SegSamplingPlanService extends GridService<SegSamplingPlan> {

    constructor(http: HttpClient) {
        super('SegSamplingPlan', http);
    }

    override get(filter: string, orderBy: string, sort: string, page: number, pageSize: number, filterBy: string, headers?: HttpHeaders): Observable<GridModel<SegSamplingPlanListResponse>> {
        return this.http.get<GridModel<SegSamplingPlanListResponse>>(this.getApiUrl(`${this.controllerName}/GetList`), {
            params: this.createParamsWithFilterBy(filter, orderBy, sort, page, pageSize, filterBy),
            headers
        });
    }
}
